/**
 * Customizations:
 * - Inseriti campi per trasparenza sul controllo qualità dei servizi del comune (#64232)
 */

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Attachment from 'design-comuni-plone-theme/components/ItaliaTheme/View/Commons/Attachment';
import RichTextSection from 'design-comuni-plone-theme/components/ItaliaTheme/View/Commons/RichTextSection';
import { richTextHasContent } from 'design-comuni-plone-theme/components/ItaliaTheme/View/Commons/RichTextRender';

const ServizioTrasparenza = ({ content }) => {
  const intl = useIntl();

  return (
    <>
      {(content.standard_qualita?.length > 0 ||
        richTextHasContent(content.azioni_miglioramento) ||
        richTextHasContent(content.suggerimenti_reclami)) && (
        <RichTextSection
          tag_id="info-qualita"
          title={intl.formatMessage(messages.info_qualita)}
        >
          {content.standard_qualita?.length > 0 && (
            <RichTextSection
              title_tag="h3"
              title_class_name="h5"
              title={intl.formatMessage(messages.standard_qualita)}
            >
              <table className="ui celled fixed table">
                <thead>
                  <tr>
                    <th>{intl.formatMessage(messages.indicatore)}</th>
                    <th>{intl.formatMessage(messages.valore_garantito)}</th>
                    <th>
                      {intl.formatMessage(messages.risultati_anno_precedente)}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {content.standard_qualita.map((item, index) => (
                    <tr key={index}>
                      <td>{item.indicatore}</td>
                      <td>{item.valore_garantito}</td>
                      <td>{item.risultati_anno_precedente}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </RichTextSection>
          )}
          {content.risultati_monitoraggio?.length > 0 && (
            <RichTextSection
              title_tag="h3"
              title_class_name="h5"
              title={intl.formatMessage(messages.risultati_monitoraggio)}
            >
              <div className="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal">
                {content.risultati_monitoraggio.map((item, index) => {
                  const itemURL = generateDownloadUrl(item);

                  return (
                    <Attachment
                      key={item['@id']}
                      title={item.title}
                      description={item.description}
                      download_url={itemURL}
                      item={item}
                    />
                  );
                })}
              </div>
            </RichTextSection>
          )}
          <RichTextSection
            title_tag="h3"
            title_class_name="h5"
            title={intl.formatMessage(messages.azioni_miglioramento)}
            data={content.azioni_miglioramento}
          />
          {content.customer_satisfaction?.length > 0 && (
            <RichTextSection
              title_tag="h3"
              title_class_name="h5"
              title={intl.formatMessage(messages.customer_satisfaction)}
            >
              <div className="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal">
                {content.customer_satisfaction.map((item, index) => {
                  const itemURL = generateDownloadUrl(item);

                  return (
                    <Attachment
                      key={item['@id']}
                      title={item.title}
                      description={item.description}
                      download_url={itemURL}
                      item={item}
                    />
                  );
                })}
              </div>
            </RichTextSection>
          )}
          <RichTextSection
            title_tag="h3"
            title_class_name="h5"
            title={intl.formatMessage(messages.suggerimenti_reclami)}
            data={content.suggerimenti_reclami}
          />
        </RichTextSection>
      )}
    </>
  );
};

export default ServizioTrasparenza;

const messages = defineMessages({
  info_qualita: {
    id: 'parma_theme__info_qualita',
    defaultMessage: 'Qualità del servizio',
  },
  indicatore: {
    id: 'parma_theme__info_qualita__indicatore',
    defaultMessage: 'Indicatore',
  },
  valore_garantito: {
    id: 'parma_theme__info_qualita__valore_garantito',
    defaultMessage: 'Valore garantito',
  },
  risultati_anno_precedente: {
    id: 'parma_theme__info_qualita__risultati_anno_precedente',
    defaultMessage: 'Risultati anno precedente',
  },
  standard_qualita: {
    id: 'parma_theme__info_qualita__standard_qualita',
    defaultMessage: 'Standard di qualità',
  },
  azioni_miglioramento: {
    id: 'parma_theme__info_qualita__azioni_miglioramento',
    defaultMessage: 'Azioni di miglioramento',
  },
  suggerimenti_reclami: {
    id: 'parma_theme__info_qualita__suggerimenti_reclami',
    defaultMessage: 'Suggerimenti e reclami',
  },
  risultati_monitoraggio: {
    id: 'parma_theme__info_qualita__risultati_monitoraggio',
    defaultMessage: 'Risultati monitoraggio standard qualità',
  },
  customer_satisfaction: {
    id: 'parma_theme__info_qualita__customer_satisfaction',
    defaultMessage: 'Customer satisfaction',
  },
});

function generateDownloadUrl(item) {
  switch (item['@type']) {
    case 'File':
      return `${item['@id']}/@@download/file`;
    case 'Link':
      return item.remoteUrl?.length > 0 ? item.remoteUrl : item['@id'];
    default:
      return item['@id'];
  }
}
